"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDataTable = void 0;
var react_1 = __importDefault(require("react"));
var EmptyDataTable = function (_a) {
    var colSpan = _a.colSpan;
    return (react_1.default.createElement("tbody", null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { colSpan: colSpan, style: {
                    textAlign: 'center',
                    padding: '2rem',
                    color: 'rgba(100, 99, 99, 1)',
                    backgroundColor: 'rgba(156, 156, 156, 0.1)',
                } }, "N\u00E3o h\u00E1 dados para serem exibidos"))));
};
exports.EmptyDataTable = EmptyDataTable;
